import { findBy } from '~/utils';
import { affirmatives } from '~/options/general';

const affirmativeVlaue = value => findBy(affirmatives, value).label;

export default affirmativeVlaue;
